var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 116,
    viewBox: "0 0 100 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3452_2611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6241 110.494L25.621 110.495L15.349 111.201C11.9139 111.437 8.94778 109.616 8.73622 107.144L7.78083 95.9771C7.77337 95.8898 7.86523 95.8116 7.98633 95.8022C8.10744 95.7927 8.21136 95.8556 8.21882 95.9429L9.17421 107.109C9.37111 109.411 12.1312 111.104 15.3276 110.885L25.5996 110.179C25.7208 110.17 25.8236 110.234 25.8298 110.322C25.8359 110.408 25.744 110.485 25.6241 110.494Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9888 9.45606C11.9888 8.35149 12.8842 7.45605 13.9888 7.45605H84.72C85.8245 7.45605 86.72 8.35149 86.72 9.45605V105.556C86.72 106.661 85.8245 107.556 84.72 107.556H13.9888C12.8842 107.556 11.9888 106.661 11.9888 105.556V9.45606Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.24724 20.6233C0.958667 19.5571 1.59313 18.4744 2.66435 18.2051L71.1343 0.987753C72.2055 0.718386 73.3078 1.36435 73.5964 2.43056L98.7528 95.3767C99.0413 96.4429 98.4069 97.5256 97.3356 97.795L28.8657 115.012C27.7945 115.282 26.6921 114.636 26.4036 113.569L1.24724 20.6233Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 21.5,
    width: 50,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 21.5,
    width: 50,
    height: 2,
    rx: 1,
    fill: "url(#paint0_linear_3452_2611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 27.5,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 33.5,
    width: 44,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 33.5,
    width: 44,
    height: 2,
    rx: 1,
    fill: "url(#paint1_linear_3452_2611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 39.5,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 45.5,
    width: 50,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 45.5,
    width: 50,
    height: 2,
    rx: 1,
    fill: "url(#paint2_linear_3452_2611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 51.5,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 57.5,
    width: 44,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 57.5,
    width: 44,
    height: 2,
    rx: 1,
    fill: "url(#paint3_linear_3452_2611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 63.5,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 69.5,
    width: 50,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 69.5,
    width: 50,
    height: 2,
    rx: 1,
    fill: "url(#paint4_linear_3452_2611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 75.5,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 81.5,
    width: 44,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 81.5,
    width: 44,
    height: 2,
    rx: 1,
    fill: "url(#paint5_linear_3452_2611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7247,
    y: 87.5,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3452_2611",
    x1: 27.7247,
    y1: 22.5,
    x2: 28.0108,
    y2: 18.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3452_2611",
    x1: 27.7247,
    y1: 34.5,
    x2: 28.0492,
    y2: 30.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3452_2611",
    x1: 27.7247,
    y1: 46.5,
    x2: 28.0108,
    y2: 42.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3452_2611",
    x1: 27.7247,
    y1: 58.5,
    x2: 28.0492,
    y2: 54.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3452_2611",
    x1: 27.7247,
    y1: 70.5,
    x2: 28.0108,
    y2: 66.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3452_2611",
    x1: 27.7247,
    y1: 82.5,
    x2: 28.0492,
    y2: 78.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3452_2611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.5505,
    height: 115,
    fill: "white",
    transform: "translate(0.724731 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentAgreement);
export default __webpack_public_path__ + "static/media/ConsentAgreement.97b5848ab2b2edc74c6aca9e135f4e7a.svg";
export { ForwardRef as ReactComponent };